import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import AuthCallback from "@/components/AuthCallback";
import Admin from "@/pages/Admin";
import CursorGlow from "@/components/CursorGlow";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import ParaQuien from "@/components/ParaQuien";
import Manifesto from "@/components/Manifesto";
import Signals from "@/components/Signals";
import Learn from "@/components/Learn";
import Funnel from "@/components/Funnel";
import PorQue from "@/components/PorQue";
import Deliverable from "@/components/Deliverable";
import Facilitator from "@/components/Facilitator";
import Faq from "@/components/Faq";
import Pricing from "@/components/Pricing";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";

let viewContentFired = false;

function Landing() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    if (!viewContentFired && typeof window.fbq === "function") {
      window.fbq("track", "ViewContent");
      viewContentFired = true;
    }
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="relative bg-plum text-rosewhite" data-testid="landing-page">
      <div className="noise-overlay" />
      <CursorGlow />
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <ParaQuien />
        <Manifesto />
        <Signals />
        <Learn />
        <Funnel />
        <PorQue />
        <Deliverable />
        <Facilitator />
        <Pricing />
        <Faq />
      </main>
      <Footer />
      <WhatsAppFloat />
      <Toaster position="bottom-center" theme="dark" />
    </div>
  );
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/admin" element={<Admin />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppRouter />
    </BrowserRouter>
  );
}

export default App;
